import { css, type Theme } from "@emotion/react";

import { easeOutCubic } from "@styles/emotion-styles/animations";
import { hexToRgba } from "@styles/emotion-styles/helpers/hexToRgba/hexToRgba";
import { zIndexLowForeground } from "@styles/emotion-styles/layers";
import { defaultTiming } from "@styles/emotion-styles/timing";

export const scrollFade = (gradientAngle: string, theme: Theme) => css`
  opacity: 0;
  content: "";
  display: block;
  transition: opacity ${defaultTiming} ${easeOutCubic};
  position: absolute;
  bottom: 0;
  height: 100%;
  width: 0.5rem;
  z-index: ${zIndexLowForeground};
  mask-image: linear-gradient(
    transparent 0%,
    ${theme.shadow.base} 10%,
    ${theme.shadow.base} 90%,
    transparent
  );

  background: linear-gradient(${gradientAngle}, transparent, ${hexToRgba(theme.shadow.base, 0.1)});
`;
